import React, { useState } from 'react';
import GoogleHome from './components/GoogleHome';
import SearchResults from './components/SearchResults';

// 検索クエリがKnowledge Panelを表示すべきかどうかを判定する関数
function shouldShowKnowledgePanel(query) {
  const normalizedQuery = query.toLowerCase();
  return normalizedQuery.includes('イタリアン') || normalizedQuery.includes('和食');
}

function getInitialState() {
  const params = new URLSearchParams(window.location.search);
  const q = params.get('q') || '';
  return { query: q, showResults: q.trim().length > 0 };
}

export default function App() {
  const initial = getInitialState();
  const [query, setQuery] = useState(initial.showResults ? '' : initial.query);
  const [searchedQuery, setSearchedQuery] = useState(initial.query);
  const [showResults, setShowResults] = useState(initial.showResults);

  const handleSearch = (q) => {
    const trimmed = q.trim();
    if (!trimmed) return;
    setSearchedQuery(trimmed);
    setShowResults(true);
  };

  const handleBack = () => {
    setShowResults(false);
    setQuery(searchedQuery);
  };

  if (showResults) {
    return (
      <SearchResults
        query={searchedQuery}
        shouldShowPanel={shouldShowKnowledgePanel(searchedQuery)}
        onBack={handleBack}
        onNewSearch={handleSearch}
      />
    );
  }

  return (
    <GoogleHome
      query={query}
      setQuery={setQuery}
      onSearch={handleSearch}
    />
  );
}
